import { create } from 'zustand'

/** Screen-level state shared across routes that has nothing to do with data. */
interface UiState {
  reauthOpen: boolean
  openReauth: () => void
  closeReauth: () => void
}

export const useUiStore = create<UiState>()((set) => ({
  reauthOpen: false,
  openReauth: () => set({ reauthOpen: true }),
  closeReauth: () => set({ reauthOpen: false }),
}))
